
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MDBSpinningPreloader, MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { MdbCalendarModule } from 'mdb-calendar';
import { MdbColorPickerModule } from 'mdb-color-picker';
import { MdbDraggableModule } from 'mdb-draggable';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { MdbSortableModule } from 'mdb-sortable';
import { MdbTableEditorModule } from 'mdb-table-editor';
import { MdbWysiwygModule } from 'mdb-wysiwyg';
import { AppRoutingModule } from './app-routing.module';
// PROTOTIPO
import { InicioComponent } from './inicio/inicio.component';
import { FooterComponent } from './footer/footer.component';
import { NavmenuComponent } from './navmenu/navmenu.component';
import { SplashComponent } from './splash/splash.component';
import { QuienessomosComponent } from './quienessomos/quienessomos.component';
import { OrganigramaComponent } from './organigrama/organigrama.component';
import { SliderimpactoComponent } from './sliderimpacto/sliderimpacto.component';
import { Splash2Component } from './splash2/splash2.component';
import { VoluntariadoComponent } from './voluntariado/voluntariado.component';
import { FormacionComponent } from './formacion/formacion.component';
import { QuehacemosComponent } from './quehacemos/quehacemos.component';

@NgModule({
  declarations: [
    AppComponent,
    InicioComponent,
    FooterComponent,
    NavmenuComponent,
    SplashComponent,
    QuienessomosComponent,
    OrganigramaComponent,
    SliderimpactoComponent,
    Splash2Component,
    VoluntariadoComponent,
    FormacionComponent,
    QuehacemosComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    MdbCalendarModule,
    MdbColorPickerModule,
    MdbDraggableModule,
    MdbFileUploadModule,
    MdbSortableModule,
    MdbTableEditorModule,
    MdbWysiwygModule,
    AppRoutingModule,
  ],
  providers: [MDBSpinningPreloader],
  bootstrap: [AppComponent],
  schemas:      [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }
